module.exports = __webpack_public_path__ + "img/my.c21d08b0.png";